module.exports = __webpack_public_path__ + "fonts/Lexend-Medium.b10a24e.woff2";